import { SET_TOKENS } from 'redux/actions/types/auth';

export const setTokens = (tokens) => {
    return {
        type: SET_TOKENS,
        payload: tokens
    }
}